import api from 'common/api';

export const getFilterOutputAPI = (params: any) => api.get('/data-reference/select', params);

export const getFilterOutputSearchAPI = (params: any) => api.post('/data-reference/search', params);

export const getUserGroupAPI = (params: any) => api.get('/common/user-grp', params);

export const getSQLKnrAPI = (params: any) => api.get('/common/sql-knr', params);

export const DOWNLOAD_OUTPUT_REPORT_EXCEL_API = '/data-reference/export-excel';

export const DOWNLOAD_OUTPUT_REPORT_CSV_API = '/data-reference/export-csv';
